import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ErrorFormatter } from '../../../shared/formatter/error.formatter';
import { RevertCloseLeadInput } from '../../../shared/models/lead/revertCloseLead.input';
import { FormsService } from '../../../shared/services/forms/forms.service';
import { LeadService } from '../../../shared/services/lead/lead.service';
import { ToastService } from '../../../shared/services/utils/toast.service';
import { TranslatorService } from '../../../shared/services/utils/translator.service';
import { LeadsComunicationService } from '../../leads/leads-comunication.service';
import { ModalsHandlerService } from '../modals.handler.service';

@Component({
  selector: 'ngx-revert-close-lead-modal',
  templateUrl: './revert-close-lead-modal.component.html',
  styleUrls: []
})
export class RevertCloseLeadModalComponent implements OnInit, AfterViewInit {

  @ViewChild('content', { static: false }) content: Element;
  revertCloseLeadInput: RevertCloseLeadInput;

  form: FormGroup;
  sending = false;

  constructor(
    private readonly modalsHandler: ModalsHandlerService,
    private readonly modalService: NgbModal,
    private readonly leadService: LeadService,
    private readonly toasterService: ToastService,
    private readonly leadComuService: LeadsComunicationService,
    private readonly spinner: NgxSpinnerService,
    private readonly translator: TranslatorService,
    private readonly errorFormatter: ErrorFormatter,
    private readonly formsService: FormsService
  ) { }

  ngOnInit(): void {
    this.form = this.formsService.initFormRevertClose();
  }

  ngAfterViewInit(): void {
    this.modalsHandler.revertCloseLeadModal.subscribe(leadId => {
      this.revertCloseLeadInput = new RevertCloseLeadInput();
      this.revertCloseLeadInput.leadId = leadId;
      this.resetForm();
      this.modalService
        .open(this.content, {
          size: 'lg',
          container: 'nb-layout',
          ariaLabelledBy: 'modal-basic-title',
          backdrop: 'static', keyboard: false
        });
    });
  }

  get f(): any {
    return this.form.controls;
  }

  revertCloseLead(): void {
    if (this.form.invalid) {
      this.spinner.hide();

      return;
    }

    this.bindForm();

    this.leadService.revertCloseLead$(this.revertCloseLeadInput).subscribe(() => {
      this.sending = true;
      this.modalService.dismissAll();
      this.leadComuService.launchReloadMyLead(this.revertCloseLeadInput.leadId);
      this.resetForm();
      this.toasterService
        .showToast(
          'success',
          // TODO Translate
          'modals.revert.close.cancel',
          'toasts.messages.lead_close_success'
        );
      this.sending = false;
    }, error => {
      this.toasterService
        .showToast(
          'error',
          this.translator.trans('toast.title.lead_revert_close_error'),
          this.errorFormatter.formatErrors(error.graphQLErrors)
        );
      this.sending = false;
    }, () => {
      this.spinner.hide();
    });
  }

  bindForm(): void {
    this.revertCloseLeadInput = this.formsService.bindRevertClose(this.revertCloseLeadInput.leadId, this.form);
  }

  resetForm(): void {
    this.form.reset();
    this.revertCloseLeadInput.comments = '';
  }
}
